export function getMembers(workspace) {
  if (!workspace) return []
  return (
    workspace?.memberCollection?.items
      .filter((member) => member.role !== 'owner')
      .map((member) => member.user) || []
  )
}
